<ng-container *ngIf="selectorType === 'tabs'">
	<ng-container *ngIf="portfolioData.length > 1">
		<div class="tab-container text-16 d-flex align-items-bottom" data-cy="portfolio-selector-tabs">
			<ng-container *ngFor="let index of displayIndexes">
				<!-- AVOID USING METHOD CALLS, PLS REVIEW AND REMOVE THIS COMMENT/REFACTOR -->
				<a
					class="portfolio-button d-flex flex-wrap align-items-center justify-content-center"
					(click)="selectPortfolio(index)"
					[ngClass]="setSelectedPortfolioCss(index)"
					attr.data-cy="portfolio-selector-tab-{{ index }}"
				>
					<div class="tab-label-container">{{ buttonNames[index] }}</div>
				</a>
			</ng-container>
		</div>
	</ng-container>
</ng-container>

<ng-container *ngIf="selectorType === 'dropdown'">
	<div class="ac-dropdown text-16">
		<label class="text-12 d-block" dcrHTMLKey="SELECT_PORTFOLIO">Select Portfolio</label>
		<select (change)="selectPortfolio($event.target.value)">
			<ng-container *ngFor="let index of displayIndexes">
				<option
					*ngIf="portfolioData[index].field['name'].formattedValue && portfolioData[index].field['portfolioType'].formattedValue === 'PORTFOLIO'"
					[value]="index"
					[acSelectOption]="buttonNames[index]"
				></option>
			</ng-container>
		</select>
	</div>
</ng-container>
